import { render, staticRenderFns } from "./lawyer-moon-head.vue?vue&type=template&id=4dd63f8e"
import script from "./lawyer-moon-head.vue?vue&type=script&lang=js"
export * from "./lawyer-moon-head.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports